module.exports = __webpack_public_path__ + "static/media/g2g.6cbf050e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/g2g.png
// module id = 334
// module chunks = 0